var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column w-100 align-items-center"},[_c('div',{staticClass:"d-flex align-items-center w-75 py-3"},[_c('img',{staticClass:"brand-image elevation-3",attrs:{"alt":"UCCLOG","width":"3%","src":_vm.Logo}}),_c('fecha-component',{staticStyle:{"padding":"0.2rem 1rem"}})],1),_c('formulario-denuncias',{staticClass:"pt-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }